var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays a compensation option with its description and selection action.
 * touches: compensation option cards and declaration compensation choices.
 * invariants: selection only emits the choose event; loading and disabled states
 * are controlled by the parent; HTML descriptions are sanitized with DOMPurify.
 * inputs: option image, title, description, button configuration and UI states.
 * outputs: renders the option and emits choose when the user selects it.
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { UiButton, UiIcon } from '@claims-ia/design-system';
let CompensationOptionCard = class CompensationOptionCard extends Vue {
};
__decorate([
    Prop({ required: true })
], CompensationOptionCard.prototype, "image", void 0);
__decorate([
    Prop({ required: true })
], CompensationOptionCard.prototype, "title", void 0);
__decorate([
    Prop({ default: undefined })
], CompensationOptionCard.prototype, "paragraph", void 0);
__decorate([
    Prop({ default: () => [] })
], CompensationOptionCard.prototype, "items", void 0);
__decorate([
    Prop({ required: true })
], CompensationOptionCard.prototype, "buttonLabel", void 0);
__decorate([
    Prop({ default: undefined })
], CompensationOptionCard.prototype, "buttonTestId", void 0);
__decorate([
    Prop({ default: undefined })
], CompensationOptionCard.prototype, "buttonVariant", void 0);
__decorate([
    Prop({ default: false })
], CompensationOptionCard.prototype, "loading", void 0);
__decorate([
    Prop({ default: false })
], CompensationOptionCard.prototype, "disabled", void 0);
CompensationOptionCard = __decorate([
    Component({
        components: { UiButton, UiIcon },
    })
], CompensationOptionCard);
export default CompensationOptionCard;
